// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.obra-recursos-container {
    margin-top: 2rem;
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    padding: 1.5rem;
}

.recursos-tabs {
    display: flex;
    gap: 1rem;
    border-bottom: 2px solid #eee;
    margin-bottom: 1.5rem;
}

.tab-btn {
    padding: 0.75rem 1.5rem;
    background: none;
    border: none;
    font-size: 1rem;
    font-weight: 600;
    color: #666;
    cursor: pointer;
    border-bottom: 3px solid transparent;
    transition: all 0.2s;
}

.tab-btn.active {
    color: #3182ce;
    border-bottom-color: #3182ce;
}

.tab-btn:hover:not(.active) {
    color: #333;
    background: #f8f9fa;
}

.recursos-actions {
    margin-bottom: 1rem;
    display: flex;
    justify-content: flex-end;
}

.btn-add {
    background: #3182ce;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 500;
}

.btn-add:hover {
    background: #1d4ed8;
}

.recursos-table {
    width: 100%;
    border-collapse: collapse;
}

.recursos-table th {
    text-align: left;
    padding: 0.75rem;
    background: #f8fafc;
    color: #64748b;
    font-weight: 600;
    font-size: 0.875rem;
}

.recursos-table td {
    padding: 0.75rem;
    border-top: 1px solid #e2e8f0;
    font-size: 0.9rem;
}

.actions-cell {
    display: flex;
    gap: 0.5rem;
}

.btn-icon {
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    color: #64748b;
}

.btn-icon:hover {
    background: #f1f5f9;
    color: #334155;
}

.btn-delete:hover {
    color: #ef4444;
    background: #fee2e2;
}

.add-form {
    background: #f8fafc;
    padding: 1.5rem;
    border-radius: 8px;
    margin-bottom: 1.5rem;
    border: 1px solid #e2e8f0;
}

.form-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
    margin-bottom: 1rem;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.form-group label {
    font-size: 0.875rem;
    font-weight: 500;
    color: #475569;
}

.form-group input,
.form-group select {
    padding: 0.5rem;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    font-size: 0.9rem;
}

.form-actions {
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
}

.btn-cancel {
    background: white;
    border: 1px solid #cbd5e1;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    cursor: pointer;
}

.btn-save {
    background: #3182ce;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    cursor: pointer;
}

.empty-state {
    text-align: center;
    padding: 3rem;
    color: #94a3b8;
    background: #f8fafc;
    border-radius: 8px;
    border: 2px dashed #e2e8f0;
}

/* Ferramentas registadas que ainda não estão na obra */
.recursos-aviso {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    flex-wrap: wrap;
    background: #fffaf0;
    border: 1px solid #fbd38d;
    color: #7b341e;
    border-radius: 8px;
    padding: 0.75rem 1rem;
    margin-bottom: 1.25rem;
    font-size: 0.9rem;
    line-height: 1.45;
}

.recursos-aviso-texto {
    flex: 1 1;
    min-width: 240px;
}

.recursos-aviso details {
    margin-top: 0.35rem;
}

.recursos-aviso summary {
    cursor: pointer;
    color: #c05621;
    font-weight: 600;
}

.recursos-aviso ul {
    margin: 0.35rem 0 0;
    padding-left: 1.25rem;
}

.recursos-aviso small {
    color: #9c4221;
}

.btn-add:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.recursos-cat {
    display: inline-block;
    margin-left: 0.5rem;
    padding: 1px 8px;
    border-radius: 10px;
    background: #ebf8ff;
    color: #2b6cb0;
    font-size: 0.72rem;
    font-weight: 600;
    white-space: nowrap;
    vertical-align: middle;
}

.recursos-bulk-actions { display:flex; flex-wrap:wrap; gap:8px; margin-bottom:16px; }
.recursos-section-hint { font-size:12px; color:#68829a; margin:0 0 14px; }
@media(max-width:600px) { .recursos-tabs { flex-wrap:wrap; gap:4px; } .recursos-bulk-actions > button { max-width:100%; } }
`, "",{"version":3,"sources":["webpack://./src/components/ObraRecursos.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA,uDAAuD;AACvD;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA,yBAAyB,YAAY,EAAE,cAAc,EAAE,OAAO,EAAE,kBAAkB,EAAE;AACpF,yBAAyB,cAAc,EAAE,aAAa,EAAE,eAAe,EAAE;AACzE,0BAA0B,iBAAiB,cAAc,EAAE,OAAO,EAAE,EAAE,kCAAkC,cAAc,EAAE,EAAE","sourcesContent":[".obra-recursos-container {\r\n    margin-top: 2rem;\r\n    background: white;\r\n    border-radius: 12px;\r\n    box-shadow: 0 2px 8px rgba(0,0,0,0.05);\r\n    padding: 1.5rem;\r\n}\r\n\r\n.recursos-tabs {\r\n    display: flex;\r\n    gap: 1rem;\r\n    border-bottom: 2px solid #eee;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.tab-btn {\r\n    padding: 0.75rem 1.5rem;\r\n    background: none;\r\n    border: none;\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    color: #666;\r\n    cursor: pointer;\r\n    border-bottom: 3px solid transparent;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.tab-btn.active {\r\n    color: #3182ce;\r\n    border-bottom-color: #3182ce;\r\n}\r\n\r\n.tab-btn:hover:not(.active) {\r\n    color: #333;\r\n    background: #f8f9fa;\r\n}\r\n\r\n.recursos-actions {\r\n    margin-bottom: 1rem;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.btn-add {\r\n    background: #3182ce;\r\n    color: white;\r\n    border: none;\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    font-weight: 500;\r\n}\r\n\r\n.btn-add:hover {\r\n    background: #1d4ed8;\r\n}\r\n\r\n.recursos-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.recursos-table th {\r\n    text-align: left;\r\n    padding: 0.75rem;\r\n    background: #f8fafc;\r\n    color: #64748b;\r\n    font-weight: 600;\r\n    font-size: 0.875rem;\r\n}\r\n\r\n.recursos-table td {\r\n    padding: 0.75rem;\r\n    border-top: 1px solid #e2e8f0;\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.actions-cell {\r\n    display: flex;\r\n    gap: 0.5rem;\r\n}\r\n\r\n.btn-icon {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    padding: 4px;\r\n    border-radius: 4px;\r\n    color: #64748b;\r\n}\r\n\r\n.btn-icon:hover {\r\n    background: #f1f5f9;\r\n    color: #334155;\r\n}\r\n\r\n.btn-delete:hover {\r\n    color: #ef4444;\r\n    background: #fee2e2;\r\n}\r\n\r\n.add-form {\r\n    background: #f8fafc;\r\n    padding: 1.5rem;\r\n    border-radius: 8px;\r\n    margin-bottom: 1.5rem;\r\n    border: 1px solid #e2e8f0;\r\n}\r\n\r\n.form-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n    gap: 1rem;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.form-group {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n}\r\n\r\n.form-group label {\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    color: #475569;\r\n}\r\n\r\n.form-group input,\r\n.form-group select {\r\n    padding: 0.5rem;\r\n    border: 1px solid #cbd5e1;\r\n    border-radius: 6px;\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.form-actions {\r\n    display: flex;\r\n    gap: 1rem;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.btn-cancel {\r\n    background: white;\r\n    border: 1px solid #cbd5e1;\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n}\r\n\r\n.btn-save {\r\n    background: #3182ce;\r\n    color: white;\r\n    border: none;\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n}\r\n\r\n.empty-state {\r\n    text-align: center;\r\n    padding: 3rem;\r\n    color: #94a3b8;\r\n    background: #f8fafc;\r\n    border-radius: 8px;\r\n    border: 2px dashed #e2e8f0;\r\n}\r\n\r\n/* Ferramentas registadas que ainda não estão na obra */\r\n.recursos-aviso {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: space-between;\r\n    gap: 1rem;\r\n    flex-wrap: wrap;\r\n    background: #fffaf0;\r\n    border: 1px solid #fbd38d;\r\n    color: #7b341e;\r\n    border-radius: 8px;\r\n    padding: 0.75rem 1rem;\r\n    margin-bottom: 1.25rem;\r\n    font-size: 0.9rem;\r\n    line-height: 1.45;\r\n}\r\n\r\n.recursos-aviso-texto {\r\n    flex: 1;\r\n    min-width: 240px;\r\n}\r\n\r\n.recursos-aviso details {\r\n    margin-top: 0.35rem;\r\n}\r\n\r\n.recursos-aviso summary {\r\n    cursor: pointer;\r\n    color: #c05621;\r\n    font-weight: 600;\r\n}\r\n\r\n.recursos-aviso ul {\r\n    margin: 0.35rem 0 0;\r\n    padding-left: 1.25rem;\r\n}\r\n\r\n.recursos-aviso small {\r\n    color: #9c4221;\r\n}\r\n\r\n.btn-add:disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.recursos-cat {\r\n    display: inline-block;\r\n    margin-left: 0.5rem;\r\n    padding: 1px 8px;\r\n    border-radius: 10px;\r\n    background: #ebf8ff;\r\n    color: #2b6cb0;\r\n    font-size: 0.72rem;\r\n    font-weight: 600;\r\n    white-space: nowrap;\r\n    vertical-align: middle;\r\n}\r\n\r\n.recursos-bulk-actions { display:flex; flex-wrap:wrap; gap:8px; margin-bottom:16px; }\r\n.recursos-section-hint { font-size:12px; color:#68829a; margin:0 0 14px; }\r\n@media(max-width:600px) { .recursos-tabs { flex-wrap:wrap; gap:4px; } .recursos-bulk-actions > button { max-width:100%; } }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
